import Phaser from 'phaser';
import { palette } from '../design/palette';
import { ANCHOR_INITIAL_Y, BAR_THICKNESS } from './Bar';

export const BALL_RADIUS = 8;
export const BALL_START_X = 180;
export const BALL_START_Y = ANCHOR_INITIAL_Y - BAR_THICKNESS / 2 - BALL_RADIUS;

// Ball is a Graphics-only object after the 1D rolling sim refactor.
// GameScene owns the physical state (x, vx) via rolling.ts and drives
// the graphic via setWorldPosition() each frame.
export class Ball {
  private gfx: Phaser.GameObjects.Graphics;
  private posX = BALL_START_X;
  private posY = BALL_START_Y;

  constructor(scene: Phaser.Scene) {
    this.gfx = scene.add.graphics();
    this.gfx.enableFilters();
    const glow = this.gfx.filters?.internal.addGlow(palette.ballHalo, 6, 0, 1, false, 10, 16);
    glow?.setPaddingOverride(-18, -18, 18, 18);
    this.gfx.setFiltersFocusContext(false);
    this.redraw();
  }

  public setWorldPosition(x: number, y: number): void {
    this.posX = x;
    this.posY = y;
    this.redraw();
  }

  public setRenderTransform(x: number, y: number, scale: number, alpha: number): void {
    this.posX = x;
    this.posY = y;
    this.gfx.setScale(scale);
    this.gfx.setAlpha(alpha);
    this.redraw();
  }

  public x(): number { return this.posX; }
  public y(): number { return this.posY; }

  public reset(): void {
    this.posX = BALL_START_X;
    this.posY = BALL_START_Y;
    this.gfx.setScale(1);
    this.gfx.setAlpha(1);
    this.redraw();
  }

  private redraw(): void {
    const size = BALL_RADIUS * 2;
    this.gfx.setPosition(this.posX, this.posY);
    this.gfx.focusFiltersOverride(size / 2, size / 2, size, size);
    this.gfx.clear();
    this.gfx.fillStyle(palette.ballCore, 1);
    this.gfx.fillCircle(0, 0, BALL_RADIUS);
  }
}
